<template>
  <div>
      <input :id="id" :name="id" ref="input" type="hidden" :value="value" @change="changeForm" >
  </div>
</template>

<script>

export default {
  name: 'nt-hidden',
  props: {
    id: {
      type: String,
      default: 'input'
    },
    validators: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selected: null,
      error: null
    }
  },
  created() {
    const { formData, validators } = this.$parent.$data
    // Add to form initial values
    Object.assign(formData, {
      [this.id]: this.value
    })
    // Add validators to form
    Object.assign(validators, {
      [this.id]: this.validators
    })
  },
  mounted() {
  },
  methods: {
    changeForm() {
      this.$parent.$emit('changeForm', {
        [this.id]: this.value
      })
    }
  }
}
</script>